import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Tab,
  Table,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";
import {
  ICourseSession,
  ICourseTerm,
} from "../../models/admin/courseTermSession.model";
import AdminHelpers from "../../services/admin/admin.service";
import coursesService from "../../services/courses.service";
import { getFullDate } from "../../utils/classOfDegree";

const SessionTerms = () => {
  const [loading, setLoading] = useState(true);

  const [reload, setReload] = useState(false);

  const toast = useToast();
  const [session, setSession] = useState("");
  const [sessions, setSessions] = useState<ICourseSession[]>([]);
  const [terms, setTerms] = useState<ICourseTerm[]>([]);
  const [term, setTerm] = useState("");
  const {
    isOpen: isTermOpen,
    onOpen: onTermOpen,
    onClose: onTermClose,
  } = useDisclosure();
  const {
    isOpen: isSessionOpen,
    onOpen: onSessionOpen,
    onClose: onSessionClose,
  } = useDisclosure();

  useEffect(() => {
    AdminHelpers.getSessions()
      .then((response) => {
        setSessions(response.data);
        setLoading(false);
      })
      .catch((err) => err);
    AdminHelpers.getTerms()
      .then((response) => {
        setTerms(response.data);
        setLoading(false);
      })
      .catch((err) => err);
  }, [reload]);
  const createTerm = () => {
    const termPayload = {
      title: term,
    };
    coursesService.createTerm(termPayload).then((res) => {
      toast({
        title: "Term",
        description: "Term created successfully",
        status: "success",
      });
      onTermClose();
      setReload(!reload);
    });
  };
  const createSession = () => {
    const termPayload = {
      title: session,
    };
    coursesService.createSession(termPayload).then((res) => {
      toast({
        title: "Session",
        description: "Session created successfully",
        status: "success",
      });
      onSessionClose();
      setReload(!reload);
    });
  };
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>
          <Box width="100%">
            <AdminDashboardHeader />
            <Box              pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden">
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Session & Term
                </Box>
                <HStack>
                  <Button
                    p="7px"
                    fontSize={12}
                    borderRadius={2}
                    colorScheme="red"
                    height="32px"
                    onClick={() => {
                      onSessionOpen();
                    }}
                  >
                    Add Session
                  </Button>
                  <Button
                    p="7px"
                    fontSize={12}
                    borderRadius={2}
                    colorScheme="red"
                    height="32px"
                    onClick={() => {
                      onTermOpen();
                    }}
                  >
                    Add Term
                  </Button>
                </HStack>
              </Flex>
              <Tabs colorScheme="red">
                <TabList>
                  <Tab>Session</Tab>
                  <Tab>Terms</Tab>
                </TabList>

                <TabPanels>
                  <TabPanel>
                    <Box width="100%">
                      <TableContainer>
                        <Table variant="simple">
                          <Thead mb="10px">
                            <Tr
                              pb="10px"
                              borderBottom="1px solid"
                              borderColor="#D5D5D5"
                            >
                              <Th width="70px">
                                <Checkbox></Checkbox>
                              </Th>
                              <Th textTransform="none">Session Name</Th>
                              <Th textTransform="none">Session Code</Th>
                              <Th textTransform="none">Date Created</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {sessions.map((each) => (
                              <Tr bg="white" key={each.id}>
                                <Td width="70px">
                                  <Checkbox></Checkbox>
                                </Td>
                                <Td>
                                  <HStack spacing="10px">
                                    <Avatar name={each.title} size="sm" />
                                    <Text
                                      fontWeight="600"
                                      fontSize="16px"
                                      color="#616161"
                                    >
                                      {each.title}
                                      <br></br>
                                      {/* Mechanical Engineering */}
                                    </Text>
                                  </HStack>
                                </Td>
                                <Td>
                                  {" "}
                                  <Text>{each.code ? each.code : ""}</Text>
                                </Td>
                                <Td>
                                  {" "}
                                  <Text>{getFullDate(each.created_at)}</Text>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </TabPanel>
                  <TabPanel>
                    <Box width="100%">
                      <TableContainer>
                        <Table variant="simple">
                          <Thead mb="10px">
                            <Tr
                              pb="10px"
                              borderBottom="1px solid"
                              borderColor="#D5D5D5"
                            >
                              <Th width="70px">
                                <Checkbox></Checkbox>
                              </Th>
                              <Th textTransform="none">Term Name</Th>
                              <Th textTransform="none">Term Code</Th>
                              <Th textTransform="none">Date Created</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {terms.map((each) => (
                              <Tr bg="white" key={each.id}>
                                <Td width="70px">
                                  <Checkbox></Checkbox>
                                </Td>
                                <Td>
                                  <HStack spacing="10px">
                                    <Avatar name={each.title} size="sm" />
                                    <Text
                                      fontWeight="600"
                                      fontSize="16px"
                                      color="#616161"
                                    >
                                      {each.title}
                                      <br></br>
                                      {/* Mechanical Engineering */}
                                    </Text>
                                  </HStack>
                                </Td>
                                <Td>
                                  {" "}
                                  <Text>{each.code ? each.code : ""}</Text>
                                </Td>
                                <Td>
                                  {" "}
                                  <Text>{getFullDate(each.created_at)}</Text>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
            <Modal isOpen={isTermOpen} onClose={onTermClose}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Add Term</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <FormControl>
                    <HStack spacing="8px">
                      <Input
                        id="term"
                        name="term"
                        placeholder="Enter term here"
                        size="md"
                        width="100%"
                        borderColor="#D5D5D5"
                        value={term}
                        onChange={(e) => setTerm(e.target.value)}
                        type="text"
                      />
                    </HStack>
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      onTermClose();
                    }}
                    mr={3}
                  >
                    Close
                  </Button>
                  <Button
                    onClick={() => {
                      createTerm();
                    }}
                  >
                    Add Term
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
            <Modal isOpen={isSessionOpen} onClose={onSessionClose}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Add Session</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <FormControl>
                    <HStack spacing="8px">
                      <Input
                        id="session"
                        name="session"
                        placeholder="Enter session here"
                        size="md"
                        width="100%"
                        borderColor="#D5D5D5"
                        value={session}
                        onChange={(e) => setSession(e.target.value)}
                        type="text"
                      />
                    </HStack>
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button
                    colorScheme="red"
                    onClick={() => {
                      onSessionClose();
                    }}
                    mr={3}
                  >
                    Close
                  </Button>
                  <Button
                    onClick={() => {
                      createSession();
                    }}
                  >
                    Add Session
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default SessionTerms;
